import { cn } from "@/lib/utils"
import { X } from "lucide-react"
import * as React from "react"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  clearable?: boolean
  onClear?: () => void
}

/**
 * Input component with consistent styling and optional clear functionality
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, clearable, onClear, value, ...props }, ref) => {
    const showClearButton = clearable && value && String(value).length > 0

    if (clearable) {
      return (
        <div className="relative">
          <input
            type={type}
            className={cn(
              "type-control flex h-10 w-full rounded-lg border border-input bg-transparent px-3 py-2 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-semibold placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
              showClearButton && "pr-8",
              className
            )}
            ref={ref}
            value={value}
            {...props}
          />
          {showClearButton && (
            <button
              type="button"
              onClick={onClear}
              className="absolute right-2 top-1/2 -translate-y-1/2 size-4 text-muted-foreground hover:text-foreground transition-colors"
            >
              <X className="size-4" />
            </button>
          )}
        </div>
      )
    }

    return (
      <input
        type={type}
        className={cn(
          "type-control flex h-10 w-full rounded-lg border border-input bg-transparent px-3 py-2 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-semibold placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        value={value}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
